import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
// import GameCard from '../../components/common/GameCard/GameCard';
// import LeaderBoard from '../../components/common/LeaderBoard/LeaderBoard';
import HowToPlay from '../../components/common/HowToPlay/HowToPlay';
import Faq from '../../components/common/Faq/Faq';
import PracticeCard from '../../components/common/PracticeCard/PracticeCard';
import s from './Common.scss';
// import RelatedArticles from '../../components/common/RelatedArticles/RelatedArticles';

import BtfContent from '../../components/common/BtfContent/BtfContent';
import ShareButton from '../../components/common/ShareButton/ShareButton';
import breadcrumbs from '../../GameBreadcrumbsHelper';
import BreadCrumb from '../../../../components_v2/common/BreadCrumb/BreadCrumb';
import CardGrid from '../../components/desktop/CardGrid/CardGrid';
import { TOI_LIVE_DOMAIN } from '../../../../constants';
import GameCardListing from '../../components/common/GameCardListing/GameCardListing';
import GenricReadMore from '../../components/common/GenricReadMore/GenricReadMore';

const GamesCatListing = props => {
  const { gameType, gamesMetaWidget } = props;
  let breadCrumbData = '';
  if (breadcrumbs && gameType === 'sudoku') {
    breadCrumbData = breadcrumbs.sudoku;
  } else if (breadcrumbs && gameType === 'mini-crossword') {
    breadCrumbData = breadcrumbs.MiniCrossword;
  } else if (breadcrumbs && gameType === 'location-guesser') {
    breadCrumbData = breadcrumbs.locationGuesser;
  } else if (breadcrumbs && gameType === 'loop-a-loop') {
    breadCrumbData = breadcrumbs.loopaloop;
  } else if (breadcrumbs && gameType === 'whos-that') {
    breadCrumbData = breadcrumbs.whosthat;
  } else if (breadcrumbs && gameType === 'connect') {
    breadCrumbData = breadcrumbs.connect;
  } else {
    breadCrumbData = breadcrumbs.crossword;
  }

  return (
    <>
      <div className={`${s.gameColumnWrap} ${s.gameCatListing}`}>
        <div className={s.leftColumn}>
          {breadCrumbData && (
            <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
          )}
          <div className={s.title}>
            {gamesMetaWidget &&
              gamesMetaWidget.metaInfo &&
              gamesMetaWidget.metaInfo.TemplateH1TopHeading &&
              gamesMetaWidget.metaInfo.TemplateH1TopHeading.value !== '' && (
                <h1>{gamesMetaWidget.metaInfo.TemplateH1TopHeading.value}</h1>
              )}
            <ShareButton
              // title={componentData.gameType}
              url={`${TOI_LIVE_DOMAIN}/games/${props.gameType}/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
              gaCat={props.gameType}
            />
          </div>
          <GameCardListing
            cardProps={{
              isVertical: true,
            }}
            cardsIncluded={[`${gameType?.replace(/-/g, '_')}`]}
            loaderClass="vertical_desktop_loader"
            pageTemplate="listing"
          />
          <div className="atfContentArea">
            <GenricReadMore information={gamesMetaWidget?.atf} isAtf />
          </div>
          {/* Listing Page Leaderboard */}
          <div className={s.howPlayBlock}>
            <div className={s.title}>
              <h2>How to play?</h2>
            </div>
            <div
              className={`${s.howPlayOuter} ${
                gameType === 'loop-a-loop' ? s.howPlayOuterLoop : ''
              } ${s.br16}`}
            >
              <HowToPlay
                gameType={gameType === 'loop-a-loop' ? 'loopaloop' : gameType}
              />
            </div>
          </div>
          {gamesMetaWidget &&
            gamesMetaWidget.relatedArticleItems &&
            Array.isArray(gamesMetaWidget.relatedArticleItems) && (
              <CardGrid
                items={gamesMetaWidget.relatedArticleItems}
                ga4Category={`${gameType?.replace(/-/g, '_')}_listing`}
                ga4Type="related_articles"
              />
            )}

          {gamesMetaWidget &&
            gamesMetaWidget.faqs &&
            Array.isArray(gamesMetaWidget.faqs) && (
              <Faq data={gamesMetaWidget.faqs} />
            )}

          <BtfContent data={gamesMetaWidget?.btf} />
        </div>
        <div className={s.rightColumn}>
          {/* <LeaderBoard gameType={gameType} /> */}
          <PracticeCard gameType={gameType} pageTemplate="listing" />
        </div>
      </div>
    </>
  );
};

GamesCatListing.propTypes = {
  gamesMetaWidget: PropTypes.shape({}),
  gameType: PropTypes.string,
};

GamesCatListing.defaultProps = {
  gamesMetaWidget: undefined,
  gameType: undefined,
};

const mapStateToProps = state => ({
  gamesMetaWidget: _get(state, 'toigames.gamesmetawidget', {}),
});

export default connect(mapStateToProps)(GamesCatListing);
